import { createSlice } from "@reduxjs/toolkit";

import {
  fetchNotificationSettings,
  updateNotificationSettings,
} from "./actions";

const initialState = {
  deadlineLeadTimeDays: null,
  loading: false,
  hasLoaded: false,
  error: null,
  saving: false,
};

const notificationSettingsSlice = createSlice({
  name: "notificationSettings",
  initialState,
  reducers: {
    setDeadlineLeadTimeDays: (state, action) => {
      state.deadlineLeadTimeDays = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setHasLoaded: (state, action) => {
      state.hasLoaded = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSaving: (state, action) => {
      state.saving = action.payload;
    },
  },
});

export const {
  setDeadlineLeadTimeDays,
  setLoading,
  setHasLoaded,
  setError,
  setSaving,
} = notificationSettingsSlice.actions;

export const loadNotificationSettings = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const settings = await fetchNotificationSettings();
    dispatch(setDeadlineLeadTimeDays(settings?.deadlineLeadTimeDays ?? null));
    dispatch(setError(null));
  } catch (error) {
    dispatch(setError(error?.message ?? "Failed to load notification settings"));
  } finally {
    dispatch(setHasLoaded(true));
    dispatch(setLoading(false));
  }
};

export const saveDeadlineLeadTimeDays =
  (deadlineLeadTimeDays) => async (dispatch) => {
    dispatch(setSaving(true));
    try {
      const settings = await updateNotificationSettings(deadlineLeadTimeDays);
      dispatch(setDeadlineLeadTimeDays(settings?.deadlineLeadTimeDays ?? null));
      return settings;
    } finally {
      dispatch(setSaving(false));
    }
  };

export default notificationSettingsSlice.reducer;
